import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import styles from "components/settings/settings-modal.scss";
import { DropdownModal } from "components/common/dropdown-modal";
import { accountType } from "custom-prop-types";

export const SettingsModal = ({
  isSettingsMode,
  onEndSettingsMode,
  onLogout,
  selectedAccount
}) => (
  <DropdownModal
    arrowSide
    offsetLeft={ -150 }
    offsetTop={ 30 }
    onClose={ onEndSettingsMode }
    visible={ isSettingsMode }
    width={ 165 }
  >
    <div className={ `${styles.links} overview7` }>
      <Link
        onClick={ onEndSettingsMode }
        to={ `/accounts/${selectedAccount.slug}/settings/account/usage` }
      >
        Settings
      </Link>
      <Link
        onClick={ onEndSettingsMode }
        to={ `/accounts/${selectedAccount.slug}/manage-envelopes` }
      >
        Manage Envelopes
      </Link>
      <a href="https://support.squirrelstreet.com" rel="noopener noreferrer" target="_blank">Help</a>
      <a href={ OLD_UI_BASE_URL } rel="noopener noreferrer">Go to old UI</a>
      <a data-name="logout-link" href="#logout" onClick={ onLogout }>Logout</a>
    </div>
  </DropdownModal>
);

SettingsModal.propTypes = {
  isSettingsMode: PropTypes.bool.isRequired,
  onEndSettingsMode: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  selectedAccount: accountType.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/settings-modal.jsx